"use client";
import ResourceFilterAndBannerWrapper from "@/app/components/filters/ResourceFilterAndBannerWrapper";
import { SubTopic, Topic } from "@tsTypes/subject-schema";
import { useCheckUserAccess } from "@utils/accessChecks";
import RestrictedResourceBanner from "../../components/banners/RestrictedResourceBanner";
import ResourceTableButtons from "../../components/tables/ResourceTableButtons";
import SyllabusTable from "./SyllabusTable";

export default function SyllabusPageLayout({
  subjectSyllabusPointData,
  syllabusButtons,
  topicDocumentIds,
  subjectDocumentId,
  subjectNameLower,
}: {
  subjectSyllabusPointData: {
    documentId: Topic["documentId"];
    TopicDescription: Topic["TopicDescription"];
    RelatedSubTopics: Pick<SubTopic, "documentId" | "RelatedSyllabusPoints">[];
  }[];
  syllabusButtons: {
    documentId: string;
    title: string;
  }[];
  topicDocumentIds: string[];
  subjectDocumentId: string;
  subjectNameLower: string;
}) {
  const userAccess = useCheckUserAccess("syllabus", subjectDocumentId);
  return (
    <>
      <ResourceFilterAndBannerWrapper hasFilters={false}>
        <RestrictedResourceBanner
          resource={"syllabus"}
          subjectDocumentId={subjectDocumentId}
          subjectName={subjectNameLower}
          userAccess={userAccess}
        />
      </ResourceFilterAndBannerWrapper>
      <ResourceTableButtons buttons={syllabusButtons} />
      {topicDocumentIds.map((documentId, index) => (
        <SyllabusTable
          key={documentId}
          subjectDocumentId={subjectDocumentId}
          subjectNameLower={subjectNameLower}
          topicSyllabusPointData={
            subjectSyllabusPointData.find(
              (data) => data.documentId === documentId
            )!
          }
          restrictAccess={userAccess !== "Full Access"}
          className={index === 0 ? "first-table-fade-in" : undefined}
        />
      ))}
    </>
  );
}
